import { color, textStyle } from '@repay/cactus-theme';
import styled from 'styled-components';
import Text from '../Text/Text';
export var Label = /*#__PURE__*/styled(Text.withComponent('label')).withConfig({
  displayName: "Label"
})(["", " font-weight:600;color:", ";"], textStyle('body'), color('darkestContrast'));
export default Label;